import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import {
  VkCommunityInstallService,
  VkInstallState,
} from '../../../services/vk-community-install.service';
import { resolveVkBindWidgetId } from '../../utils/vk-bind-widget-params';

@Component({
  selector: 'app-vk-community-install',
  templateUrl: './vk-community-install.component.html',
  styleUrls: ['./vk-community-install.component.scss'],
})
export class VkCommunityInstallComponent implements OnInit {
  active = false;
  widgetId: string | null = null;
  appId: string | null = null;
  state: VkInstallState = 'idle';
  error = '';

  constructor(
    private route: ActivatedRoute,
    private vkCommunityInstallService: VkCommunityInstallService,
  ) {}

  ngOnInit(): void {
    this.route.queryParams.subscribe((params) => {
      const widgetId = resolveVkBindWidgetId(params);
      if (!widgetId) {
        this.active = false;
        this.widgetId = null;
        this.appId = null;
        return;
      }

      this.active = true;
      this.widgetId = widgetId;
      this.appId = params['api_id'] || null;
    });
  }

  async onInstallClick(): Promise<void> {
    if (!this.widgetId) {
      this.state = 'error';
      this.error =
        'Не удалось определить виджет. Откройте установку из CRM повторно.';
      return;
    }

    this.state = 'installing';
    this.error = '';

    const result = await this.vkCommunityInstallService.install(
      this.widgetId,
      this.appId || undefined,
    );

    if (result === 'error') {
      this.state = 'error';
      this.error =
        'Не удалось установить приложение. Убедитесь, что страница открыта во ВКонтакте и вы администратор сообщества.';
    }
  }
}
